// Layout: Recent Projects
import fixCenterModeSwipe from "../../assets/src/js/features/slick-center-swipe";

document.addEventListener("DOMContentLoaded", function () {
	const $slider = $(".recent-projects__slider");
	if (!$slider.length) return;

	// Slick clones only (slidesToShow + 1) slides per side for the infinite
	// loop; with variableWidth several slides are visible at once, so
	// slidesToShow: 1 left backward drags exposing blank track. Raise it
	// (capped below the real slide count so clones still get built) purely
	// to deepen the clone buffer — variableWidth controls the layout.
	const cloneDepth = Math.max(1, Math.min(5, $slider.children().length - 1));

	// Initialize Slick — center mode with variable width
	$slider.slick({
		centerMode: true,
		variableWidth: true,
		infinite: true,
		speed: 650,
		slidesToShow: cloneDepth,
		slidesToScroll: 1,
		arrows: false,
		dots: false,
		focusOnSelect: true,
		swipeToSlide: true,
		// Low commit distance (~2% of track width) so quick flicks always
		// advance instead of snapping back; ease-out settle reads as momentum.
		touchThreshold: 50,
		cssEase: "cubic-bezier(0.16, 1, 0.3, 1)",
	});

	// Correct multi-slide swipe traversal for centerMode + variableWidth
	fixCenterModeSwipe($slider);

	// Custom arrow bindings
	$(".recent-projects__prev").on("click", function () {
		$slider.slick("slickPrev");
	});
	$(".recent-projects__next").on("click", function () {
		$slider.slick("slickNext");
	});

	function isMobile() {
		return window.innerWidth < 1024;
	}

	function playVideo(video) {
		if (!video) return;
		video.muted = true;
		const p = video.play();
		if (p !== undefined) {
			p.catch(function () {
				// Autoplay blocked — nothing more we can do
			});
		}
	}

	// Autoplay every primary video at rest (desktop + mobile center slide — safe
	// because muted + playsinline satisfy iOS autoplay)
	$slider.find('video[data-role="primary"]').each(function () {
		playVideo(this);
	});

	// Mobile: keep all primaries playing; pause hover videos defensively
	function handleMobileAutoplay() {
		if (!isMobile()) return;
		$slider.find(".recent-projects__slide").each(function () {
			const primary = $(this).find('video[data-role="primary"]')[0];
			const hover = $(this).find('video[data-role="hover"]')[0];
			if (primary) playVideo(primary);
			if (hover) {
				hover.pause();
				hover.currentTime = 0;
			}
		});
	}

	$slider.on("afterChange", function () {
		handleMobileAutoplay();
	});

	handleMobileAutoplay();

	// Desktop hover: swap to hover layer, pause primary, play hover video from 0
	$slider.on("mouseenter", ".recent-projects__slide", function () {
		if (isMobile()) return;
		const $slide = $(this);
		$slide.addClass("is-hovered");

		const primary = $slide.find('video[data-role="primary"]')[0];
		const hover = $slide.find('video[data-role="hover"]')[0];

		if (primary) primary.pause();
		if (hover) {
			hover.currentTime = 0;
			playVideo(hover);
		}
	});

	$slider.on("mouseleave", ".recent-projects__slide", function () {
		if (isMobile()) return;
		const $slide = $(this);
		$slide.removeClass("is-hovered");

		const primary = $slide.find('video[data-role="primary"]')[0];
		const hover = $slide.find('video[data-role="hover"]')[0];

		if (hover) {
			hover.pause();
			hover.currentTime = 0;
		}
		if (primary) playVideo(primary);
	});
});
